<template>
	<v-card class="message">
		<!-- <code>{{message}}</code> -->
		<v-list class="pt-3 pb-0">
			<v-list-tile class="message__title">
				<v-list-tile-avatar>
					<img :src="message.from.photo_url" :alt="message.from.name" v-if="!sent" />
					<img :src="user.photo_url" :alt="user.name" v-else />
				</v-list-tile-avatar>

				<v-list-tile-content>
					<v-list-tile-title v-if="!sent">
						<span v-html="message_from"></span>
						<span :class="{'error--text': isUnread}">posted a new {{message.type}}.</span>
					</v-list-tile-title>

					<v-list-tile-title v-if="sent">
						<span class="error--text">You sent a message to</span>
						{{recipients}}
					</v-list-tile-title>

					<v-list-tile-sub-title class="tertiary--text">{{message.created_at | moment("from", "now")}}</v-list-tile-sub-title>
				</v-list-tile-content>

				<v-list-tile-action v-if="!sent">
					<v-menu bottom left offset-x open-on-hover content-class="more-menu">
						<v-btn slot="activator" icon small>
							<div class="v-icon">
								<fa-icon :icon="['far', 'ellipsis-v']" size="xs" />
							</div>
						</v-btn>

						<v-list class="pa-0">
							<v-list-tile v-if="isUnread" @click="changeStatus('read')">
								<v-list-tile-title>Mark as read</v-list-tile-title>
							</v-list-tile>

							<v-list-tile v-if="isRead && !isArchived" @click="changeStatus('unread')">
								<v-list-tile-title>Mark as unread</v-list-tile-title>
							</v-list-tile>

							<v-list-tile v-if="!isArchived" @click="changeStatus('archived')">
								<v-list-tile-title>Archive</v-list-tile-title>
							</v-list-tile>

							<v-list-tile v-if="isArchived" @click="changeStatus('unarchived')">
								<v-list-tile-title>Unarchive</v-list-tile-title>
							</v-list-tile>
						</v-list>
					</v-menu>
				</v-list-tile-action>
			</v-list-tile>
		</v-list>

		<v-card-text v-html="message_body" class="message__body"></v-card-text>

		<link-prevue v-show="urls.length > 0" v-for="(url, i) in urls" :url="url" :key="i">
			<template slot-scope="props">
				<v-card-text class="message__unfurl unfurl">
					<a
						v-bind:href="props.url"
						v-if="props.img"
						class="unfurl__img-link"
						:style="`background-image: url(${props.img})`"
					></a>
					<div class="unfurl__content">
						<h4 class="subheading">
							<a v-bind:href="props.url">{{props.title}}</a>
						</h4>
						<div class="body-1 mt-1" v-if="props.description">{{props.description}}</div>
					</div>
				</v-card-text>
			</template>
		</link-prevue>

		<v-card-text
			v-if="message.attachments.length"
			class="py-2"
			:class="!dark ? 'accent lighten-4' : 'black'"
		>
			<div v-for="attachment in message.attachments" :key="attachment.id">
				<a :href="attachment.path" target="_blank">
					<fa-icon :icon="['far', 'paperclip']" fixed-width size="sm" />
					{{attachment.name}}
				</a>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import LinkPrevue from "link-prevue";

export default {
	data() {
		return {
			urlRegex: /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi,
			urls: []
		};
	},
	components: {
		LinkPrevue
	},

	props: {
		message: {
			default() {
				return {};
			}
		},

		sent: {
			default: false
		}
	},

	computed: {
		...mapGetters(["dark", "searchQuery", "user"]),

		searchRegex() {
			return new RegExp(this.searchQuery, "gi");
		},

		isUnread() {
			return this.getObjectValue("message.pivot.read_at", this) === null;
		},

		isRead() {
			return this.getObjectValue("message.pivot.read_at", this) !== null;
		},

		isArchived() {
			return (
				this.getObjectValue("message.pivot.archived_at", this) !== null
			);
		},

		recipients() {
			if (!this.sent) {
				return "";
			}

			return _.join(
				_.map(this.message.to, item => {
					return item.name;
				}),
				", "
			);
		},

		message_body() {
			let body = this.message.body;
			let target = "";

			body = body.replace(this.urlRegex, url => {
				if (this.urls.indexOf(url) === -1) {
					this.urls.push(url);
				}

				if (url.indexOf(window.location.hostname) === -1) {
					target = 'target="_blank"';
				}

				return `<a href="${url}" ${target}>${url}</a>`;
			});

			if (this.searchQuery) {
				return this.highlight(body);
			}

			return body;
		},

		message_from() {
			let from = this.message.from.name;

			if (this.searchQuery) {
				return this.highlight(from);
			}

			return from;
		}
	},

	methods: {
		...mapActions("messages", { CHANGE_STATUS: "changeStatus" }),

		highlight(text) {
			let regex = new RegExp(
				`(?!<a href=".*)${this.searchQuery}(?![^><]*")`,
				"gi"
			);

			return (text = text.replace(regex, found => {
				return `<span class="search-highlight">${found}</span>`;
			}));
		},

		changeStatus(status) {
			this.message.status = status;
			this.CHANGE_STATUS(this.message);
		}
	}
};
</script>
